const hasSiteAccess = (selectedAccess, site) => {
    if(site) {
        const index = selectedAccess.sites.findIndex(accessSite => accessSite._id === site)
        return index > -1;
    } else {
        return true
    }    
}

export default hasSiteAccess;